<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" :key="error" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.fieldset}">
      <select :value="fieldset" name="fieldset" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select Field
        </option>
        <option v-for="(field, value) in config.blockFieldsets" :key="value" :value="value">
          {{ field.label }}
        </option>
      </select>
    </div>
    <div v-if="fieldset">
      <div v-if="config.blockFieldsets[fieldset].numeric">
        <span v-if="fieldsForDropdown.length > 1">
          <select :value="exportTag" name="exportTag" class="form-control" @change="handleChange">
            <option disabled :value="null">Select field</option>
            <option v-for="field in fieldsForDropdown" :key="field.name" :value="field.name">{{ field.name }}</option>
          </select>
        </span>
        <span :class="{'has-error':errors.operator}">
          <select :value="operator" name="operator" class="form-control selectpicker" @change="handleChange">
            <option value="" selected="selected">Select Operator</option>
            <optgroup label="All">
              <option value="textEmpty">Is Empty</option>
              <option value="textNotEmpty">Is Not Empty</option>
            </optgroup>
            <optgroup label="Numeric">
              <option value="lt">&lt;</option>
              <option value="lte">≤</option>
              <option value="gt">&gt;</option>
              <option value="gte">≥</option>
              <option value="eq">=</option>
              <option value="neq">≠</option>
            </optgroup>
            <optgroup label="Text">
              <option value="contains">Contains</option>
              <option value="doesNotContain">Does Not Contain</option>
              <option value="startsWith">Starts With</option>
              <option value="endsWith">Ends With</option>
              <option value="textEquals">Equals</option>
              <option value="textDoesNotEqual">Does Not Equal</option>
            </optgroup>
          </select>
        </span>
        <span v-if="operator && operatorTakesArgs">
          <select :value="amountortarget" name="amountortarget" class="form-control" @change="handleChange">
            <option v-if="operatorIsNumeric" value="amount">Exact Amount</option>
            <option v-if="!operatorIsNumeric" value="text">Text Input</option>
            <option value="variable">Variable Value</option>
          </select>
          <span v-if="operatorIsNumeric && amountortarget === 'amount'" :class="{'has-error':errors.amount}">
            <input :value="amount" name="amount" class="form-control input-numeric" @input="handleChange">
          </span>

          <span v-else-if="!operatorIsNumeric && amountortarget === 'text'" :class="{'has-error':errors.text}">
            <input
              :value="text"
              name="text"
              class="form-control"
              placeholder="Text Input"
              @input="handleChange"
            >
          </span>
          <span v-else-if="amountortarget === 'variable'" :class="{'has-error':errors.variable}">
            <select :value="variable" name="variable" class="form-control" @change="handleChange">
              <option value="" selected="selected">Select a variable</option>
              <template v-for="($variable, $id) in config.studyVariables">
                <option v-if="operatorIsNumeric == $variable.is_numeric" :key="$id" :value="$id">{{ $variable.name }}</option>
              </template>
            </select>
          </span>
        </span>
      </div>

      <div v-else :class="{'has-error':errors.compliantChoices}">
        is one of
        <div v-for="(label, value) in config.blockFieldsets[fieldset].choices" :key="value">
          <input
            :id="value"
            v-model="selectedCompliantChoices"
            :value="value"
            type="checkbox"
            name="compliantChoices"
          >
          <label>{{ label }}</label>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import { nonNumericOperators, unaryOperators } from "@/EventLogic/operators";
  import IfBlockFormFieldValidator from './IfBlockFormFieldValidator';

  export default {
    extends: BaseComponent,

    props: {
      fieldset: String,
      exportTag: String, // look at this specific field rather than the fieldset as a whole
      amountortarget: {
        type: String,
        default: 'amount'
      },
      // Fundamentally a number, but often stored as a string
      amount: [Number, String],
      text: String,
      variable: [Number, String],
      operator: String,
      compliantChoices: {
        type: Array,
        default: () => []
      },
      id: String,
    },
    data: function () {
      return {
        selectedCompliantChoices: this.compliantChoices,
      }
    },
    computed: {
      operatorIsNumeric: function () {
        return nonNumericOperators.includes(this.operator) === false;
      },
      operatorTakesArgs: function() {
        return unaryOperators.includes(this.operator) === false;
      },
      activeFieldset() {
        return this.config.blockFieldsets[this.fieldset];
      },
      fieldsForDropdown() {
        if (!this.activeFieldset) {
          return [];
        }
        return this.activeFieldset
          .fields
          .filter(field => field.type === 'number');
      },
    },
    watch: {
      selectedCompliantChoices: function () {
        this.$emit('update:compliantChoices', this.selectedCompliantChoices);
      },
      compliantChoices: function (value) {
        this.selectedCompliantChoices = value;
      },
      'operatorIsNumeric': function (isNumeric) {
        if (!this.operatorTakesArgs) {
          // force operators without a right-hand side to be text
          this.$emit('update:amountortarget', 'text');
        } else if (this.amountortarget !== 'variable') {
          if (isNumeric) {
            this.$emit('update:amountortarget', 'amount');
          } else {
            this.$emit('update:amountortarget', 'text');
          }
        }
      }
    },
    methods: {
      validate: function () {
        this.errors = IfBlockFormFieldValidator(this, this.config);

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
